export default "__VITE_ASSET__DMvEbEeA__"